import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';
import { storeClinicFeatures } from '../../Utils/clinicFeatures';

/**
 * The logged-in user's own clinic feature flags (Super Admin → Feature control).
 *
 * The response is cached into storage on the way through, because route guards
 * have to answer "may this clinic open /viewer?" synchronously, before any
 * component has mounted or any selector has run.
 */
export const getClinicFeaturesApi = createAsyncThunk(
  'clinicFeatures/get',
  async (_, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
      };

      const res = await fetch(CLINICS.FEATURES_URL, requestOptions);

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to fetch feature flags');
      }

      const data = await res.json();
      storeClinicFeatures(data?.result?.features);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
